import Quill from "quill";
const Embed: any = Quill.import('blots/embed');

export class RightshipInspectionStatusMarker extends Embed {

    static tagName = 'span';
    static className = 'statuses';
    static blotName = 'rightship-inspection-status-marker';

    static create(value: string) {
        const node = super.create(value);
        node.textContent = value;
        return node;
    }

    static value(domNode: HTMLElement) {
        return domNode.textContent;
    }

    index() {
        return 1;
    }
}
